/* eslint-disable no-param-reassign */

export default {
  name: 'uiStore',

  state: {
    section: '',
    printContent: '',
    displaySnack: false,
    snackMessage: '',
  },

  getters: {
    section: state => state.section,
    printContent: state => state.printContent,
    displaySnack: state => state.displaySnack,
    snackMessage: state => state.snackMessage,
  },

  mutations: {
    setSection(state, name) {
      state.section = name;
    },

    setPrintContent(state, url) {
      state.printContent = url;
    },

    showSnack(state, text) {
      state.snackMessage = text;
      state.displaySnack = true;

      setTimeout(() => {
        state.displaySnack = false;
      }, 3000);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/ui-store.js